<div class="row">
    <div class="col-12 ">
        <label for="url" class="form-label">Url</label>
        <input type="text" class="form-control" id="url" name="url" ngModel #url="ngModel" [(ngModel)]="authConfig.url"
            required />
    </div>
    <div class="col-12 ">
        <label for="url" class="form-label">ApiKey</label>
        <div class="input-group">
            <input type="{{ showApiKey ? 'text' : 'password' }}" class="form-control" id="apiKey" name="apiKey" ngModel
                #url="ngModel" [(ngModel)]="authConfig.apiKey" autocomplete="new-password" required />
            <button type="button" class="btn btn-outline-secondary" (click)="showApiKey = !showApiKey" tabindex="-1">
                <i [ngClass]="showApiKey ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
            </button>
        </div>
    </div>
    <div class="col-md-6 ">
        <label for="name" class="form-label">Username</label>
        <input type="text" class="form-control" id="username" name="username" ngModel #name="ngModel" autocomplete="off"
            [(ngModel)]="authConfig.username" required />
    </div>
    <div class="col-md-6 ">
        <label for="name" class="form-label">Password</label>

        <div class="input-group">
            <input type="{{ showPassword ? 'text' : 'password' }}" class="form-control" id="password" name="password"
                autocomplete="new-password" ngModel #name="ngModel" [(ngModel)]="authConfig.password" required />
            <button type="button" class="btn btn-outline-secondary" (click)="showPassword = !showPassword"
                tabindex="-1">
                <i [ngClass]="showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
            </button>
        </div>
    </div>
    <div class="col-md-6 ">
        <label for="name" class="form-label">Realm</label>
        <input type="text" class="form-control" id="realm" name="realm" ngModel #name="ngModel"
            [(ngModel)]="authConfig.realm" required />


    </div>
</div>